import * as React from 'react';

function BlueTickIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <path
          id="dxw6e9g8na"
          d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-2.652-1.054-5.196-2.929-7.071C17.196 3.054 14.652 2 12 2zm4.3 7.61l-4.57 6c-.189.245-.48.39-.79.39-.308.002-.6-.139-.79-.38l-2.44-3.11c-.22-.282-.272-.66-.138-.992.135-.331.436-.565.79-.615.355-.049.708.095.928.377l1.63 2.08 3.78-5c.218-.286.572-.434.928-.388.357.046.662.279.8.61.139.332.09.712-.128.998v.03z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g transform="translate(-925 -307) translate(440 146) translate(50 146) translate(435 15)">
                <path d="M0 0H24V24H0z" />
                <mask id="jskq5ik6tb" fill="#fff">
                  <use xlinkHref="#dxw6e9g8na" />
                </mask>
                <g fill="#55D3FF" mask="url(#jskq5ik6tb)">
                  <path d="M0 0H24V24H0z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BlueTickIcon;
